import { render, staticRenderFns } from "./view-block.vue?vue&type=template&id=6fb98822&"
import script from "./view-block.vue?vue&type=script&lang=js&"
export * from "./view-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports